import type { Portal } from "@/features/auth/types";

export const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  /** Public doctor search for booking without signing in (GUEST_BOOKING_ENABLED). */
  BOOK: "/book",

  PATIENT_HOME: "/patient",
  PATIENT_FIND_DOCTORS: "/patient/doctors",
  PATIENT_DOCTOR: "/patient/doctors/:doctorId",
  PATIENT_APPOINTMENTS: "/patient/appointments",

  DOCTOR_HOME: "/doctor",
  DOCTOR_APPOINTMENTS: "/doctor/appointments",
  DOCTOR_SCHEDULE: "/doctor/schedule",
  DOCTOR_PROFILE: "/doctor/profile",

  ADMIN_HOME: "/admin",
  ADMIN_DOCTORS: "/admin/doctors",
  ADMIN_DOCTOR_NEW: "/admin/doctors/new",
  ADMIN_DOCTOR_DETAIL: "/admin/doctors/:doctorId",
  ADMIN_APPOINTMENTS: "/admin/appointments",
  ADMIN_MASTER_DATA: "/admin/master-data",

  EXECUTIVE_HOME: "/executive",
  EXECUTIVE_APPOINTMENTS: "/executive/appointments",

  ACCOUNT_PROFILE: "/account/profile",
  ACCOUNT_SECURITY: "/account/security",
  NOT_FOUND: "*",
} as const;

/** Home page that loads automatically for each portal after sign-in. */
export const PORTAL_HOME: Record<Portal, string> = {
  PATIENT: ROUTES.PATIENT_HOME,
  DOCTOR: ROUTES.DOCTOR_HOME,
  ADMIN: ROUTES.ADMIN_HOME,
  EXECUTIVE: ROUTES.EXECUTIVE_HOME,
};

export const homeFor = (portal: Portal | null | undefined) => (portal ? PORTAL_HOME[portal] : ROUTES.LOGIN);
